<template>
  <div>
    <div :id=id type="text/plain"></div>
  </div>
</template>
<script>
  import '../../public/UE/ueditor.config.js'
  import '../../public/UE/ueditor.all.js'
  import '../../public/UE/lang/zh-cn/zh-cn.js'
  import '../../public/UE/ueditor.parse.min'
  import '../../public/UE/add'
  import {get_qiniu_token, toQiniu} from '../api/open'

  export default {
    name: 'vueQuillEditor',
    data() {
      return {
        progs: '',
        id: 'sc' + Math.random(),
        editorOption: {
          modules: {
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike', 'image'],        // toggled buttons
                ['blockquote', 'code-block'],
                [{'color': []}, {'background': []}],
                [{'font': []}],
                [{'align': []}],
                [{'size': ['small', false, 'large', 'huge']}],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                ['link', 'image']
              ],
              handlers: {
                'image': function (value) {
                  if (value) {
                    document.querySelector('#file').click()
                  } else {
                    this.quill.format('image', false)
                  }
                }
              }
            },
          }
        },
        qiniu: {},
        editor: {},
        flag: true,
      }
    },
    props: ['prog'],
    methods: {
      updateImg() {
        let img = document.querySelector('#file').files[0]
        let formdata = new FormData()
        formdata.append('file', img)
        this.getQiutoken(formdata)
      },
      getQiutoken(formdata) {
        let para = {}
        get_qiniu_token(para).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.sendQiniu(data.content, formdata)
          } else {
          }
        }).catch(err => {
          console.log(err)
        })
      },
      sendQiniu(qiniu, formdata) {
        let upToken = qiniu.upToken
        let domain = qiniu.domain
        formdata.append('token', upToken)
        toQiniu(formdata).then(res => {
          let data = res.data
          let img = 'https://' + domain + '/' + data.key
          // 获取富文本组件实例
          let quill = this.$refs.myQuillEditor.quill
          console.log(quill)
          // 如果上传成功
          // 获取光标所在位置
          let length = quill.getSelection().index
          // 插入图片  res.info为服务器返回的图片地址
          quill.insertEmbed(length, 'image', img)
          // 调整光标到最后
          quill.setSelection(length + 1)
        }).catch(err => {
          console.log(err)
        })
      },
      onEditorChange: function () {
        // console.log(this.progs);
        // this.$emit('editResult', this.progs)
      },
      onEditorBlur($event) {
        // console.log(this.progs);
      },
      getUEContent() { // 获取内容方法
        // this.$emit('editResult', this.editor.getContent())
      },
    },
    watch: {
      prog() {
        this.progs = this.prog
        this.$nextTick(function () {
          const _this = this
          if (_this.flag) {
            _this.editor.setContent(_this.progs)
            _this.flag = false
          }
        })

      },
    },
    mounted() {
      const _this = this
      _this.progs = this.prog
      _this.editor = UE.getEditor(_this.id) // 初始化UE
      _this.editor.addListener('ready', function () {
        _this.editor.setContent(_this.progs) // 确保UE加载完成后，放入内容。
      })
      _this.editor.addListener('selectionchange', function (editor) {
        _this.$emit('editResult', _this.editor.getContent())
      })
      _this.editor.addListener('contentChange', function (editor) {
        _this.$emit('editResult', _this.editor.getContent())
      })

    },
    created() {


    }
  }
</script>
<style>
  .edui-default .edui-editor-iframeholder {
    min-height: 400px !important;
  }

  .edui-default img {
    width: 100% !important;

  }

</style>
<style>
  .edui-default .edui-button-body, .edui-splitbutton-body, .edui-menubutton-body, .edui-combox-body {
    height: 20px;
  }

  .edui-default .edui-toolbar .edui-combox .edui-combox-body {
    height: 20px;
  }
</style>
